"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6 4H4v11.451h11.964l-3.176 3.142L14.21 20l5.785-5.723-5.785-5.722-1.422 1.406 3.528 3.49H6V4z" }), "Paragraph");
//# sourceMappingURL=Paragraph.js.map